import { ArrowForwardIcon, Flex } from '@pancakeswap/uikit'
import { UserDataResp } from 'config/types/Authentication'
import { WalletType } from 'config/types/Wallet'
import { useTranslation } from 'contexts/Localization'
import { formatCode } from 'helpers/CommonHelper'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { USER_ROLE } from 'config/constants'
import BaseButton from 'widgets/BaseButton'
import classNames from 'classnames'
import { Button, Switch } from 'antd'
import { useTheme } from 'next-themes'
import { Copy2Icon } from 'widgets'

import Accordion from './Accordion'
import { MenuEntry, MenuLink, MenuSubEntry } from './MenuEntry'
import { MenuEntry as MenuEntryTypes } from './types'

const Wrapper = styled.div<{ visible: boolean }>`
  position: fixed;
  width: 100vw;
  height: 100vh;
  padding: 110px 16px 32px;
  z-index: 11;
  overflow: auto;
  transition: 0.25s;
  transform: ${({ visible }) => (visible ? 'translateX(0)' : 'translateX(100%)')};

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ul li {
    list-style: none;
  }
`

const MenuActionsMobile = styled.div`
  margin-top: 24px;
  position: relative;

  .auth-btn {
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.sign-in {
      background-color: transparent;
      background-image: url('/images/connect/sign-in-button-bg.png');
      background-repeat: no-repeat;
      background-size: cover;

      :hover {
        box-shadow: none;
      }
    }

    &.sign-up {
      border-color: 2px solid #9bde00;
      margin-top: 16px;
      :hover {
        background-color: transparent;
        background-image: url('/images/connect/sign-in-button-bg.png');
        background-repeat: no-repeat;
        background-size: cover;
      }
    }
  }
`

const SwichStyled = styled(Switch)`
  &:not(.ant-switch-checked) {
    background-color: rgba(0, 0, 0, 0.25) !important;
  }
`

const UserBox = styled(Flex)`
  img {
    width: 50px;
    height: 50px;
    margin-right: 16px;
  }

  > div {
    svg {
      fill: #969999;
      width: 16px;
      height: 16px;
    }

    p {
      font-size: 18px;
      font-weight: 700;
      line-height: 24px;
    }

    .address-copy {
      padding: 0;
      max-width: 110px;

      .wrapper-input {
        padding: 0;

        .ant-input-affix-wrapper {
          padding: 0;
        }

        input.ant-input {
          color: #969999;
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
        }
      }
    }
  }
`

interface Props {
  visible: boolean
  links: MenuEntryTypes[]
  accountEllipsis?: string
  toggleWallet: () => void
  toggleMenu: () => void
  userData: UserDataResp
  onSignOut: () => void
  myWallet: WalletType
}

const MobileSlider = ({ visible, links, toggleMenu, userData, onSignOut, myWallet }: Props) => {
  const router = useRouter()
  const { t } = useTranslation()
  const { theme, setTheme } = useTheme()

  return (
    <>
      <Wrapper className="bg-white dark:bg-[#070f0f]" visible={visible}>
        <ul>
          {userData && (
            <UserBox as="li" alignItems="center" justifyContent="space-between">
              <Flex>
                <Flex as="img" src={userData?.avatar} alt="" alignItems="center" justifyContent="center" />
                <Flex flexDirection="column">
                  <p className="text-black dark:text-white mb-2">{userData?.fullName}</p>

                  <div className="flex items-center gap-1">
                    <p className="flex items-center gap-1 dark:text-white text-black font-light text-sm">
                      <span className="text-text-secondary text-sm font-light">Wallet: </span>
                      {formatCode(myWallet?.address, 5, 5)}
                    </p>

                    <div>
                      <Copy2Icon textCopy={myWallet?.address} />
                    </div>
                  </div>
                  <div className="flex items-center gap-1">
                    <p className="flex items-center gap-1 dark:text-white text-black font-light text-sm">
                      <span className="text-text-secondary text-sm font-light">UID: </span>
                      {formatCode(userData?.id, 5, 5)}
                    </p>
                    <div>
                      <Copy2Icon textCopy={userData?.id} />
                    </div>
                  </div>
                </Flex>
              </Flex>

              <ArrowForwardIcon
                pathClassName="fill-black dark:fill-white"
                width="32px"
                onClick={() => {
                  router.push('/profile')
                  toggleMenu()
                }}
              />
            </UserBox>
          )}

          {links.map((entry: any) => {
            const paths = router.pathname.split('/').map((path) => `/${path}`)
            const isActive = entry.actives.includes(paths[1])
            if (entry.items) {
              return (
                <Accordion key={`menu-${entry.label}`} label={entry.label} isActive={isActive}>
                  {entry.items.map((subMenu) => {
                    return (
                      <MenuSubEntry
                        key={`sub-${subMenu.label}`}
                        className={paths.includes(subMenu.href || '') ? 'active' : ''}
                        onClick={toggleMenu}
                      >
                        <MenuLink href={subMenu.href}>{subMenu.label}</MenuLink>
                      </MenuSubEntry>
                    )
                  })}
                </Accordion>
              )
            }
            return (
              <MenuEntry key={`menu-${entry.label}`} onClick={toggleMenu}>
                <MenuLink
                  className={classNames('hover:dark:text-primary hover:text-gray-400 text-black dark:text-white', {
                    'text-black dark:text-primary dark:border-0 border-b border-solid border-gray-400': paths.includes(
                      entry.href || '',
                    ),
                  })}
                  href={entry.href}
                >
                  {t(entry.label)}
                </MenuLink>
              </MenuEntry>
            )
          })}

          {/* <MenuEntry className="flex justify-between items-center">
            <MenuLink className={classNames('hover:text-gray-400 text-black dark:text-white')} href="/reward">
              {t('Dark Mode')}
            </MenuLink>
            <SwichStyled
              checked={theme === 'dark'}
              onChange={(checked) => setTheme(checked ? 'dark' : 'light')}
              className="!min-w-fit !min-h-fit w-12"
            />
          </MenuEntry> */}

          {userData && (
            <>
              {userData?.role === USER_ROLE.ADMIN && (
                <>
                  <MenuEntry onClick={toggleMenu}>
                    <MenuLink
                      className={classNames('hover:dark:text-primary hover:text-gray-400 text-black dark:text-white')}
                      href="/admin"
                    >
                      {t('Admin')}
                    </MenuLink>
                  </MenuEntry>
                  <MenuEntry onClick={toggleMenu}>
                    <MenuLink
                      className={classNames('hover:dark:text-primary hover:text-gray-400 text-black dark:text-white')}
                      href="/reward"
                    >
                      {t('Reward')}
                    </MenuLink>
                  </MenuEntry>
                  <MenuEntry onClick={toggleMenu}>
                    <MenuLink
                      className={classNames('hover:dark:text-primary hover:text-gray-400 text-black dark:text-white')}
                      href="/withdraw-requests"
                    >
                      {t('Withdraw Request')}
                    </MenuLink>
                  </MenuEntry>
                </>
              )}

              <MenuEntry
                onClick={() => {
                  onSignOut()
                  toggleMenu()
                }}
              >
                <MenuLink
                  className={classNames('hover:dark:text-primary hover:text-gray-400 text-black dark:text-white')}
                  href="/reward"
                >
                  {t('Sign out')}
                </MenuLink>
              </MenuEntry>
            </>
          )}
        </ul>

        <MenuActionsMobile>
          {/* <LocalizeSelector /> */}
          {/* <BaseButton
            className="open-app-btn"
            onClick={() => {
              router.push('/connect')
            }}
          >
            <div>{accountEllipsis || 'OPEN APP'}</div>
          </BaseButton> */}

          {!userData && (
            <div className="flex flex-col gap-5">
              <Button type="primary" onClick={() => router.push('/sign-in')}>
                {t('Sign in')}
              </Button>
              <Button ghost type="primary" onClick={() => router.push('/sign-up')}>
                {t('Sign up')}
              </Button>
            </div>
          )}
        </MenuActionsMobile>
      </Wrapper>
    </>
  )
}
export default MobileSlider
